(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  var root = document.currentScript ? document.currentScript.closest('.kbcol') : document.querySelector('.kbcol');
  if (!root) return;

  var filters = root.querySelector('[id="kbcol-filters"]');
  var openBtn = root.querySelector('[data-kbcol-open]');
  var closeBtn = root.querySelector('[data-kbcol-close]');
  var overlay = root.querySelector('[data-kbcol-overlay]');
  var form = root.querySelector('[data-kbcol-form]');
  var sortForm = root.querySelector('[data-kbcol-sort]');
  var filterTrap = (filters && window.kbTrap) ? window.kbTrap(filters, openBtn) : null;

  // Auto-submit bij sorteer-wijziging
  if (sortForm) {
    var sortSelect = sortForm.querySelector('select[name="sort_by"]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () { sortForm.submit(); });
    }
  }

  function isDrawer() { return true; }

  function openDrawer() {
    if (!filters) return;
    filters.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (isDrawer() && filterTrap) { filterTrap.on(); }
  }
  function closeDrawer() {
    if (!filters) return;
    filters.classList.remove('is-open');
    if (overlay) overlay.hidden = true;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (filterTrap) { filterTrap.off(); }
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && filters && filters.classList.contains('is-open')) closeDrawer();
  });

  // Auto-submit op desktop bij checkbox/prijs-wijziging; in drawer wacht op "Toon resultaten"
  if (form) {
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || (t.type !== 'checkbox' && t.type !== 'number')) return;
      if (isDrawer()) return;
      form.submit();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  var mq = window.matchMedia('(min-width: 860px)');
  document.querySelectorAll('.kbfoot').forEach(function (foot) {
    var cols = Array.prototype.slice.call(foot.querySelectorAll('.kbfoot__col'));
    function sync() { cols.forEach(function (c) { c.open = mq.matches; }); }
    sync();
    cols.forEach(function (c) {
      var head = c.querySelector('.kbfoot__col-head');
      if (head) head.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
    });
    if (mq.addEventListener) { mq.addEventListener('change', sync); }
    else if (mq.addListener) { mq.addListener(sync); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-dogs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-hd]').forEach(function (root) {
  var track = root.querySelector('[data-hd-track]');
  if (!track) return;
  var step = function () {
    var slide = track.querySelector('.hd__slide');
    return slide ? slide.getBoundingClientRect().width + 16 : 300;
  };
  var prev = root.querySelector('[data-hd-prev]');
  var next = root.querySelector('[data-hd-next]');
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var wrapper   = document.querySelector('.site-header__wrapper');
  var searchBar = document.querySelector('.site-header__search-bar');
  var overlay   = document.getElementById('nav-overlay');
  var triggers  = document.querySelectorAll('[data-nav-trigger]');
  var closeTimer = null;
  var openTimer  = null;
  var activeDD   = null;

  function updateTop() {
    if (!wrapper) return;
    var h = wrapper.getBoundingClientRect().bottom;
    document.querySelectorAll('.site-header__dropdown').forEach(function (d) {
      d.style.top = h + 'px';
    });
  }
  updateTop();
  window.addEventListener('resize', updateTop, { passive: true });

  /* Slimme sticky header: verberg bij naar beneden scrollen, toon bij naar boven scrollen */
  var headerGroup = wrapper ? wrapper.closest('.shopify-section-group-header-group') : null;
  if (headerGroup) {
    var lastY = window.scrollY || 0, hticking = false;
    window.addEventListener('scroll', function () {
      if (hticking) return;
      hticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || 0;
        var ddOpen = document.querySelector('[data-nav-dropdown][data-open]');
        if (y < 90 || ddOpen) {
          headerGroup.classList.remove('kb-hide');          /* bovenaan of menu open → altijd tonen */
        } else if (y > lastY + 6) {
          headerGroup.classList.add('kb-hide');             /* omlaag → verbergen */
        } else if (y < lastY - 6) {
          headerGroup.classList.remove('kb-hide');          /* omhoog → tonen */
        }
        lastY = y;
        hticking = false;
      });
    }, { passive: true });
  }

  function openDD(dd, trigger) {
    clearTimeout(closeTimer);
    clearTimeout(openTimer);
    updateTop(); /* herbereken positie t.o.v. de (sticky) header bij openen, ook na scrollen */
    if (activeDD && activeDD !== dd) closeDD(activeDD, null);
    dd.setAttribute('data-open', '');
    trigger && trigger.setAttribute('aria-expanded', 'true');
    overlay && overlay.setAttribute('aria-hidden', 'false');
    activeDD = dd;
  }

  function closeDD(dd, trigger) {
    dd.removeAttribute('data-open');
    var t = trigger || dd.closest('.site-header__chip-item') && dd.closest('.site-header__chip-item').querySelector('[data-nav-trigger]');
    t && t.setAttribute('aria-expanded', 'false');
  }

  function closeAll() {
    closeTimer = setTimeout(function () {
      document.querySelectorAll('[data-nav-dropdown][data-open]').forEach(function (d) { closeDD(d, null); });
      overlay && overlay.setAttribute('aria-hidden', 'true');
      activeDD = null;
    }, 120);
  }

  triggers.forEach(function (trigger) {
    var item = trigger.closest('.site-header__chip-item--has-dd');
    var dd   = item && item.querySelector('[data-nav-dropdown]');
    if (!dd) return;

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { openDD(dd, trigger); }, 80);
    });
    item.addEventListener('mouseleave', closeAll);

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (trigger.getAttribute('aria-expanded') === 'true') closeAll();
        else openDD(dd, trigger);
      }
      if (e.key === 'Escape') { closeAll(); trigger.focus(); }
    });
  });

  document.querySelectorAll('[data-nav-dropdown]').forEach(function (dd) {
    dd.addEventListener('mouseenter', function () { clearTimeout(closeTimer); clearTimeout(openTimer); });
    dd.addEventListener('mouseleave', closeAll);
  });

  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && activeDD) closeAll(); });

  /* ── Zoekpaneel ──────────────────────────────────────── */
  var searchToggle  = document.querySelector('[data-search-toggle]');
  var searchPanel   = document.getElementById('header-search-panel');
  var searchInput   = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchClear   = document.querySelector('[data-search-clear]');
  var searchForm    = document.querySelector('[data-search-form]');

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !open);
      searchPanel.setAttribute('aria-hidden', open);
      if (!open && searchInput) setTimeout(function () { searchInput.focus(); }, 300);
    });
  }

  if (searchInput && searchResults) {
    var SEARCH_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var debounceTimer = null;
    var activeIndex = -1;
    function money(c) { var n = parseFloat(c); return isNaN(n) ? '' : '\u20ac' + n.toFixed(2).replace('.', ','); }
    function opts() { return searchResults.querySelectorAll('[role="option"]'); }
    function openList() { searchResults.hidden = false; searchInput.setAttribute('aria-expanded', 'true'); }
    function closeList() { searchResults.hidden = true; searchInput.setAttribute('aria-expanded', 'false'); setActive(-1); }
    function setActive(idx) {
      var list = opts();
      activeIndex = idx;
      list.forEach(function (el, i) {
        var on = i === idx;
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        el.classList.toggle('is-active', on);
        if (on) { searchInput.setAttribute('aria-activedescendant', el.id); el.scrollIntoView({ block: 'nearest' }); }
      });
      if (idx < 0) searchInput.removeAttribute('aria-activedescendant');
    }
    // Resultaten via DOM-nodes + textContent (geen innerHTML met API-data).
    function renderResults(results, q) {
      while (searchResults.firstChild) { searchResults.removeChild(searchResults.firstChild); }
      activeIndex = -1;
      if (!results.length) { closeList(); return; }
      results.forEach(function (i, idx) {
        var a = document.createElement('a');
        a.href = i.url;
        a.className = 'search-result-item';
        a.id = 'search-opt-' + idx;
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        var img;
        if (i.image) {
          img = document.createElement('img');
          img.src = i.image; img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy';
          img.className = 'search-result-item__img';
        } else {
          img = document.createElement('div');
          img.className = 'search-result-item__img';
        }
        a.appendChild(img);
        var wrap = document.createElement('span');
        var title = document.createElement('span');
        title.className = 'search-result-item__title';
        title.textContent = i.title;
        wrap.appendChild(title);
        if (i.price) {
          var price = document.createElement('span');
          price.className = 'search-result-item__price';
          price.textContent = money(i.price);
          wrap.appendChild(price);
        }
        a.appendChild(wrap);
        searchResults.appendChild(a);
      });
      var all = document.createElement('a');
      all.href = SEARCH_ROOT + 'search?type=product&q=' + encodeURIComponent(q);
      all.className = 'search-result-item__all';
      all.id = 'search-opt-all';
      all.setAttribute('role', 'option');
      all.setAttribute('aria-selected', 'false');
      all.textContent = 'Alle resultaten \u2192';
      searchResults.appendChild(all);
      openList();
    }
    function fetchSuggestions(q) {
      if (q.length < 2) { closeList(); return; }
      fetch(SEARCH_ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var p = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(p.map(function (x) {
            var src = (x.featured_image && x.featured_image.url) || x.image || null;
            if (src && src.indexOf('width=') === -1) { src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=96'; }
            return { title: x.title, url: x.url, image: src, price: x.price };
          }), q);
        }).catch(function () { closeList(); });
    }
    searchInput.addEventListener('input', function () {
      var q = this.value.trim();
      searchClear && (searchClear.hidden = q.length === 0);
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 220);
    });
    searchInput.addEventListener('keydown', function (e) {
      var list = opts();
      if (searchResults.hidden || !list.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive((activeIndex + 1) % list.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((activeIndex - 1 + list.length) % list.length); }
      else if (e.key === 'Enter') { if (activeIndex >= 0 && list[activeIndex]) { e.preventDefault(); list[activeIndex].click(); } }
      else if (e.key === 'Escape') { closeList(); }
    });
    searchClear && searchClear.addEventListener('click', function () { searchInput.value = ''; searchInput.focus(); this.hidden = true; closeList(); });
    document.addEventListener('click', function (e) {
      if (searchForm && !searchForm.contains(e.target) && searchToggle && !searchToggle.contains(e.target)) closeList();
    });
  }

  /* ── Mobiel drawer ───────────────────────────────────── */
  var drawer  = document.getElementById('header-drawer');
  var drOvrl  = document.getElementById('header-overlay');
  var burger  = document.querySelector('.site-header__burger');
  var closeBtn = document.querySelector('[data-drawer-close]');
  var drawerTrap = (drawer && window.kbTrap) ? window.kbTrap(drawer, burger) : null;

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden','false');
    drOvrl && drOvrl.setAttribute('aria-hidden','false');
    burger && burger.setAttribute('aria-expanded','true');
    document.documentElement.style.overflow = 'hidden';
    if (drawerTrap) { drawerTrap.on(); } else if (closeBtn) { closeBtn.focus(); }
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden','true');
    drOvrl && drOvrl.setAttribute('aria-hidden','true');
    burger && burger.setAttribute('aria-expanded','false');
    document.documentElement.style.overflow = '';
    if (drawerTrap) { drawerTrap.off(); } else if (burger) { burger.focus(); }
  }
  burger   && burger.addEventListener('click', openDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  drOvrl   && drOvrl.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });
  document.querySelectorAll('.header-drawer__sub-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var exp = this.getAttribute('aria-expanded') === 'true';
      var sub = this.closest('.header-drawer__nav-item').querySelector('.header-drawer__sub-nav');
      this.setAttribute('aria-expanded', !exp);
      if (sub) sub.hidden = exp;
    });
  });

  /* Announcement-slider: mobiel 1 bericht per keer auto-roteren */
  (function () {
    var annList = document.querySelector('.site-header__trust-track .site-header__trust-list:not(.site-header__trust-list--clone)');
    if (!annList) return;
    var annItems = annList.querySelectorAll('.site-header__trust-item');
    if (annItems.length < 2) return;
    var annTimer = null, annIdx = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 989px)');

    function annShow(n) {
      annItems.forEach(function (el, i) { el.classList.toggle('is-active', i === n); });
    }
    function annStart() {
      if (annTimer || reduce.matches) return;
      annList.classList.add('is-rotating');
      annIdx = 0; annShow(0);
      annTimer = setInterval(function () {
        annIdx = (annIdx + 1) % annItems.length;
        annShow(annIdx);
      }, 3200);
    }
    function annStop() {
      if (annTimer) { clearInterval(annTimer); annTimer = null; }
      annList.classList.remove('is-rotating');
      annItems.forEach(function (el) { el.classList.remove('is-active'); });
    }
    function annSync() { if (mobile.matches) annStart(); else annStop(); }

    (mobile.addEventListener ? mobile.addEventListener('change', annSync) : mobile.addListener(annSync));
    (reduce.addEventListener ? reduce.addEventListener('change', annSync) : reduce.addListener(annSync));
    annSync();
  }());
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-kwispelbox"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-main] .pdp-gallery__slide');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === id); });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });

    /* Mobiele swipe-gallery: dots synchroniseren met scroll-positie (en slide is-active meesyncen). */
    var galMain = gallery.querySelector('[data-gallery-main]');
    var galDots = gallery.querySelectorAll('[data-gallery-dots] .pdp-gallery__dot');
    if (galMain && galDots.length) {
      var syncGalleryDots = function () {
        var w = galMain.clientWidth;
        if (!w) return;
        var idx = Math.round(galMain.scrollLeft / w);
        galDots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      };
      galMain.addEventListener('scroll', function () { window.requestAnimationFrame(syncGalleryDots); }, { passive: true });
      galDots.forEach(function (d, i) {
        d.addEventListener('click', function () { galMain.scrollTo({ left: i * galMain.clientWidth, behavior: 'smooth' }); });
      });
    }

    /* Klik-to-zoom lightbox */
    var lightbox = gallery.querySelector('[data-lightbox]');
    var zoomBtn = gallery.querySelector('[data-zoom]');
    if (lightbox && zoomBtn) {
      var lbImg = lightbox.querySelector('[data-lightbox-img]');
      var lbClose = lightbox.querySelector('[data-lightbox-close]');
      var lbTrap = window.kbTrap ? window.kbTrap(lightbox, zoomBtn) : null;
      var openLb = function () {
        var active = gallery.querySelector('[data-gallery-main] .pdp-gallery__slide.is-active img');
        if (!active) return;
        lbImg.src = active.currentSrc || active.src;
        lbImg.alt = active.alt || '';
        lightbox.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        if (lbTrap) { lbTrap.on(); } else { lbClose.focus(); }
      };
      var closeLb = function () { lightbox.hidden = true; document.documentElement.style.overflow = ''; if (lbTrap) { lbTrap.off(); } else { zoomBtn.focus(); } };
      zoomBtn.addEventListener('click', openLb);
      lbClose.addEventListener('click', closeLb);
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lightbox.hidden) closeLb(); });
    }
  });

  var form = document.getElementById('pdp-form');
  if (form) {
    var hidden = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var saveEl = document.querySelector('[data-save]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var valueTotal = document.querySelector('[data-value-total]');
    var valueWas = document.querySelector('[data-value-was]');
    var valueNow = document.querySelector('[data-value-now]');
    /* Euro-bedrag (hele euro's = decimaal) Nederlands formatteren: € 1.234,95 */
    var fmtEuro = function (amount) {
      try {
        return '€' + amount.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (err) {
        return '€' + amount.toFixed(2).replace('.', ',');
      }
    };
    form.querySelectorAll('input[name="variant-choice"][type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (hidden) hidden.value = radio.value;
        if (radio.dataset.variantPrice) {
          if (priceEl) priceEl.textContent = radio.dataset.variantPrice;
          if (stickyPrice) stickyPrice.textContent = radio.dataset.variantPrice;
        }
        if (compareEl) {
          if (radio.dataset.variantCompare) { compareEl.textContent = radio.dataset.variantCompare; compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        if (saveEl) {
          if (radio.dataset.variantSave) { saveEl.textContent = radio.dataset.variantSave; saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }
        /* Waarde-stack: 'jij betaalt' + 'totale waarde' meeschalen met de gekozen variant */
        if (valueNow && radio.dataset.variantValue) { valueNow.textContent = radio.dataset.variantValue; }
        if (valueTotal && valueWas) {
          var base = parseFloat(valueTotal.getAttribute('data-value-base'));        /* totale waarde standaard-box, in euro's */
          var priceBase = parseFloat(valueTotal.getAttribute('data-price-base'));    /* prijs standaard-box, in centen */
          var cents = radio.dataset.variantPriceCents ? parseFloat(radio.dataset.variantPriceCents) : NaN;
          if (!isNaN(base) && !isNaN(priceBase) && priceBase > 0 && !isNaN(cents)) {
            valueWas.textContent = fmtEuro(base * (cents / priceBase));
          }
        }
      });
    });
  }

  /* Sticky koopbalk: tonen wanneer hoofd-ATC uit beeld is en niet onderaan de pagina */
  var sticky = document.querySelector('[data-sticky]');
  var mainBtn = form ? form.querySelector('.pdp-atc__btn') : null;
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    var atcVisible = true, nearBottom = false;
    var refresh = function () { sticky.classList.toggle('is-visible', !atcVisible && !nearBottom); };
    new IntersectionObserver(function (entries) { atcVisible = entries[0].isIntersecting; refresh(); }, { rootMargin: '0px 0px -10% 0px' }).observe(mainBtn);
    window.addEventListener('scroll', function () {
      nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 90);
      refresh();
    }, { passive: true });
  }

  /* Naam-echo: typ de hondennaam → ATC-knoppen worden "Verras {naam}".
     Leeg → terug naar de ingestelde standaardtekst (data-atc-default). */
  var dogNameInput = document.querySelector('[data-dog-name]');
  if (dogNameInput) {
    var labelEls = Array.prototype.slice.call(document.querySelectorAll('[data-atc-label]'));
    var atcSummaryEl = document.querySelector('.pdp-atc__summary');
    var atcSummaryDefault = atcSummaryEl ? atcSummaryEl.textContent : '';
    var syncName = function () {
      var name = dogNameInput.value.trim();
      labelEls.forEach(function (el) {
        /* 'Uitverkocht' nooit overschrijven: alleen labels met een standaard-attribuut. */
        var def = el.getAttribute('data-atc-default');
        if (def == null) { return; }
        el.textContent = name ? ('Verras ' + name) : def;
      });
      if (atcSummaryEl) {
        atcSummaryEl.textContent = name
          ? (name + ' krijgt een cadeautje dat met liefde is ingepakt')
          : atcSummaryDefault;
      }
    };
    dogNameInput.addEventListener('input', syncName);
    syncName();
  }

  /* Levertijd-belofte is nu vaste, betrouwbare tekst (server-side uit globale settings);
     de onbetrouwbare browser-klok is verwijderd. */

  /* Countdown — interval wordt opgeruimd bij expiratie, gepauzeerd bij verborgen tab
     of wanneer de teller uit beeld is, om INP/CPU-werk te beperken. */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    var out = el.querySelector('[data-countdown-time]');
    if (isNaN(target) || !out) return;
    var timer = null, expired = false, onScreen = true;
    var tick = function () {
      var diff = target - Date.now();
      if (diff <= 0) { el.style.display = 'none'; expired = true; stop(); return; }
      var d = Math.floor(diff / 86400000), h = Math.floor(diff % 86400000 / 3600000),
          m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
      out.textContent = (d > 0 ? d + 'd ' : '') + h + 'u ' + m + 'm ' + s + 's';
    };
    var stop = function () { if (timer !== null) { clearInterval(timer); timer = null; } };
    var start = function () {
      if (timer !== null || expired || document.hidden || !onScreen) return;
      tick();
      if (!expired) { timer = setInterval(tick, 1000); }
    };
    tick();
    if (!expired) { timer = setInterval(tick, 1000); }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen) { start(); } else { stop(); }
      }).observe(el);
    }
  });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
}());

/* Aantal-stepper */
(function () {
  document.querySelectorAll('.pdp-qty').forEach(function (wrap) {
    var input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    function clamp() { var v = parseInt(input.value, 10); if (isNaN(v) || v < 1) v = 1; input.value = v; }
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    input.addEventListener('change', clamp);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-extras"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pex-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // fallback: normale POST
      e.preventDefault();
      var btn = form.querySelector('[data-pex-add]');
      var body = new FormData(form);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () {
          if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
          /* GWP meesyncen via gedeelde functie (opent de drawer NIET); dispatcht kb:cart:updated. */
          return window.kbGwp ? window.kbGwp.sync() : fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('.site-header__cart-count, .header-drawer__cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        })
        .catch(function () { form.submit(); });
    });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.querySelector('.rev__cards');
  var dots = document.querySelectorAll('[data-rev-dot]');
  if (!track || dots.length < 2) return;
  var cards = track.querySelectorAll('.rev-card');
  function setActive(i) { for (var n = 0; n < dots.length; n++) dots[n].classList.toggle('is-active', n === i); }
  var raf;
  track.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      var idx = Math.round(track.scrollLeft / (track.scrollWidth / cards.length));
      if (idx < 0) idx = 0;
      if (idx >= cards.length) idx = cards.length - 1;
      setActive(idx);
    });
  }, { passive: true });
  dots.forEach(function (d, n) {
    d.addEventListener('click', function () {
      cards[n].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
